import React, { useEffect, useState } from 'react';
import { useWindowSize } from 'usehooks-ts';
import COUNTRYDATA from '../../assets/countries.json';
import PopulationData from '../../assets/population.json';
import { Flexbox, FlexboxColumn } from '../../components/action/Flexbox';
import Address from '../../components/Address';
import { BlueBadge } from '../../components/Badge/Badge';
import Icons from '../../components/icons/Icons';
import ThemedText from '../../components/theme/ThemedText';
import ThemeLogo from '../../components/theme/ThemeLogo';
import { useLoginHelper } from '../../helpers/login/loginHelper';
import { useGlobalState } from '../../state/GlobalStateProvider';
import { groupCountriesByContinent } from '../../utils';
import Map from '../test/map';
import Details from './Sidebar/Details';
import EditApplication from './Sidebar/EditApplication';
import Forms from './Sidebar/Forms';
import Sidebar from './Sidebar/Sidebar';
import Submitted from './Sidebar/Submitted';
import './Whitelist.scss';

const Whitelist = () => {
  const [showSideBar, setShowSideBar] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [continent, setContinent] = useState();
  const [countries, setCountries] = useState();
  const [viewApplication, setViewApplication] = useState(false);
  const [displayContinet, setDisplayContinent] = useState();
  const [{ user }] = useGlobalState();
  const { userLogout } = useLoginHelper();

  const { width } = useWindowSize();

  function handleViewApplication() {
    setViewApplication(!viewApplication);
  }
  function handleSidebar() {
    setShowSideBar(!showSideBar);
  }

  function handleContinent(name) {
    const groupedData = groupCountriesByContinent(COUNTRYDATA);
    if (name == 'Australia') {
      setContinent('Oceania');
      setCountries(groupedData?.['Oceania'] || []);
    } else {
      setContinent(name);
      setCountries(groupedData?.[name] || []);
    }
  }

  function closeAndOpenApplication(){
    handleSidebar()
    handleViewApplication()

  }

  const STEPS = [
    <Details handleClose={handleSidebar} onNext={onNext} worldData={{ continent, countries }} />,
    <Forms onBack={onBack} onNext={onNext} worldData={{ continent, countries }} />,
    <Submitted handleClose={handleSidebar} handleApplication={closeAndOpenApplication}  />,
  ];

  function onNext() {
    if (STEPS.length - 1 <= currentStep) return;
    setCurrentStep(currentStep + 1);
  }

  function onBack() {
    if (currentStep <= 0) return;
    setCurrentStep(currentStep - 1);
  }

  function handleDisplayContinent(name) {
    if (name == 'Australia') {
      setDisplayContinent('Oceania');
    } else {
      setDisplayContinent(name);
    }
  }

  useEffect(() => {
    if (!user) return setCurrentStep(0);
    localStorage.setItem(`onboarding_${user?.address}`, true);
    if (user?.seedApplicant) {
      setCurrentStep(2);
    }
  }, [user]);

  useEffect(() => {}, []);

  const Continents = ['Asia', 'Africa', 'North America', 'South America', 'Europe', 'Oceania'];
  return (
    <div className='whitelist_wrapper' style={{ overflow: 'hidden' }}>
      {viewApplication && <EditApplication handleClose={handleViewApplication} />}
      {showSideBar && <Sidebar handleClose={handleSidebar}>{STEPS[currentStep]}</Sidebar>}
      <Flexbox className='whitelist_wrapper__navbar' justifyContent='space-between'>
        <Flexbox>
          <ThemeLogo icon={'mercleLogoWhite'} />
          {width >= 600 && (
            <>
              <ThemeLogo icon={'verticalLine'} />
              <ThemedText.h4 weight='medium'>Human Hub Waitlist</ThemedText.h4>
            </>
          )}
        </Flexbox>
        {user && (
          <Flexbox>
            <Address a={user?.address} redirect={false} />
            <div onClick={userLogout}>
              <Icons icon={'logout'} />
            </div>
          </Flexbox>
        )}
      </Flexbox>
      <FlexboxColumn className='whitelist_wrapper__map_container' fw alignItems={'flex-start'} justifyContent={'flex-start'} gap='2rem'>
        {width < 600 && <ThemedText.h3 weight='semi-bold'>HUMAN HUB WAITLIST</ThemedText.h3>}

        {width >= 600 && (
          <>
            <FlexboxColumn gap='0.25rem' alignItems={'flex-start'}>
              <ThemedText.h1 weight='semi-bold'>{displayContinet || 'Earth'}</ThemedText.h1>
              <Flexbox gap='0.5rem'>
                <ThemedText.h3>{PopulationData[displayContinet || 'Earth']?.population}</ThemedText.h3>
                <BlueBadge text={PopulationData[displayContinet || 'Earth']?.percentage} />
              </Flexbox>
              <ThemedText.p weight='medium'>Population</ThemedText.p>
            </FlexboxColumn>
            <Map
              handleSidebar={handleSidebar}
              handleContinent={handleContinent}
              handleDisplayContinent={handleDisplayContinent}
              displayContinet={displayContinet}
            />
          </>
        )}
        {width < 600 && (
          <FlexboxColumn fw alignItems={'flex-start'} style={{ marginTop: '2rem' }}>
            <ThemedText.h5>SELECT CONTINENT</ThemedText.h5>
            {Continents.map(item => (
              <ThemedText.h4
                className='whitelist_wrapper__continent_name'
                onClick={() => {
                  handleContinent(item);
                  handleSidebar();
                }}
              >
                {item}
              </ThemedText.h4>
            ))}
          </FlexboxColumn>
        )}
      </FlexboxColumn>
    </div>
  );
};

export default Whitelist;
